import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { authWorkspaceSchema, composeAuthWorkspace } from "../../schemas/auth";
import { removeNullishFromShape } from "../../utilities/general";

const requestSchema = yup.object({
  wpuId: yup.number().required(),
  otp: yup.string().required(),
  trustDevice: yup.boolean().notRequired(),
  method: yup.string().notRequired(),
});

const responseSchema = yup.object({
  accessToken: yup.string().nullable(),
  workspaces: yup.array().of(authWorkspaceSchema).required(),
  trustedDeviceToken: yup.string().nullable(),
  userHash: yup.string().nullable(),
});

const composeResponse = (res) => {
  const data = res?.data?.data || {};

  return {
    accessToken: data.tokens?.web || null,
    workspaces: data?.workspaces?.map(composeAuthWorkspace) || [],
    trustedDeviceToken: data?.trusted_device_token || null,
    userHash: data?.user_hash || null,
  };
};

export function useVerify2FaOtpMutation(options = {}) {
  return useMutation(async (dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    const res = await http.post(
      HTTP_ENDPOINTS.postVerify2FaOtp(),
      removeNullishFromShape({
        wpuId: req.wpuId,
        otp: req.otp,
        trusted_device: req.trustDevice,
        method: req.method,
      }),
    );
    return responseSchema.validateSync(composeResponse(res), {
      strict: true,
    });
  }, options);
}
